/* eslint-disable quotes */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Dialog from './Dialog';
// import { SAVE_LOAD_TYPE } from './utils';
// import LoadingButton from './LoadingButton';
// import { cleanBeforeExport } from '../blockly/utils';
import * as style from '../style';
import { translate } from '../../../common/i18n';
// import googleDriveUtil from '../../../common/integrations/GoogleDrive';
// import { observer as globalObserver } from '../../../common/utils/observer';

const Copy = React.memo(({ closeDialog, onSave }) => {
    // const [isLoading, setLoading] = React.useState(false);
    const [tokens, setTokens] = useState(['']); // Initialize with one empty token

    const isLocalhost = window.location.hostname === 'localhost';
    // const [isGdLoggedIn, setGdLoggedIn] = React.useState(false);

    // const isMounted = useIsMounted();

    // React.useEffect(() => {
    //     globalObserver.register('googledrive.authorised', data => setGdLoggedIn(data));
    // }, []);

    // const onChange = e =>
    // e.target.type === 'checkbox' ? setSaveType(e.target.value) : setSaveAsCollection(e.target.checked);

    const addInput = () => {
        setTokens([...tokens, '']); // Add a new empty token
    };

    const handleInputChange = (index, value) => {
        const newTokens = [...tokens];
        newTokens[index] = value;
        setTokens(newTokens);
    };

    const removeInput = index => {
        const newTokens = tokens.filter((_, i) => i !== index);
        setTokens(newTokens);
    };

    const onSubmit = e => {
        e.preventDefault();
        const tokenObjects = tokens.filter(token => token.trim() !== '').map(token => ({ token }));
        onSave(tokenObjects);
    };

    return (
        <form id="copy-dialog" onSubmit={onSubmit} className="dialog-content" style={style.content}>
            <h2 style={{ color: '#FFB300', marginBottom: '-15px' }}>{translate('Tokens for Copy Trading')}</h2>
            <h6 style={{ color: '#9E9E9E', marginBottom: '10px' }}>
                {translate(
                    'Insert the tokens that you want to copy the trades with. To work, all tokens must be valid. They will copy the same stake, trade type, and market.'
                )}
            </h6>
            {tokens.map((token, index) => (
                <div className="input-row-copy-trading" key={index} style={{ display: 'flex', alignItems: 'center' }}>
                    <h6 style={{ color: '#9E9E9E', width: '150px' }}>{translate(`Account Token ${index + 1}`)}</h6>
                    <input
                        className="copy-trading-input"
                        name={`token${index + 1}`}
                        title={translate('Account token')}
                        type="text"
                        value={token}
                        onChange={e => handleInputChange(index, e.target.value)}
                        data-lpignore="true"
                        autoComplete="false"
                        style={{ flexGrow: 1, marginRight: '10px' }}
                    />

                    <button
                        data-i18n-title="Show Copy Trading"
                        type="button"
                        className="copy-trading-button icon-trash"
                        onClick={() => removeInput(index)}
                    ></button>
                </div>
            ))}
            <div className="center-text input-row">
                <button type="button" onClick={addInput} style={{ background: '#66BB6A', color: '#212121' }}>
                    {translate('Add Token')}
                </button>
            </div>
            <div className="center-text input-row last">
                <button type="submit" style={{ background: '#FFCA28', color: '#151b1e' }}>
                    {translate('Save')}
                </button>
            </div>
        </form>
    );
});

Copy.propTypes = {
    closeDialog: PropTypes.func.isRequired,
    onSave     : PropTypes.func.isRequired,
};

export default class CopyDialog extends Dialog {
    constructor() {
        const closeDialog = token => {
            this.close(token);
        };
        const onSave = arg => {
            this.limitsPromise(arg);
            closeDialog();
        };
        super(
            'copy-dialog',
            translate('Copy Trading Tokens'),
            <Copy onSave={onSave} closeDialog={closeDialog} />,
            style.dialogLayout
        );
        this.registerCloseOnOtherDialog();
    }

    save() {
        this.open();
        return new Promise(resolve => {
            this.limitsPromise = resolve;
        });
    }
}



// WEBPACK FOOTER //
// ./src/botPage/view/Dialogs/CopyDialog.js